import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'checkout_payment';
export const route = 'checkout_payment/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "flights_payment_page" */
/* webpackPrefetch: true */
'../components/PaymentPage')));